import React from "react";
import AppPrompt from "../components/AppPrompt";

const NoActiveChatsPage: React.FC = () => {
  const handleOpenStore = () => {
    // 👉 You can improve this later with device detection
    window.open("https://apps.apple.com", "_blank");
  };

  const handleOpenApp = () => {
    // 👉 deep link to your app (replace later)
    window.location.href = "idless://open";
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9f9f9",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          background: "#ffffff",
          borderRadius: 16,
          padding: "32px 24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        {/* Logo */}
        <img
          src="/idlesslogo.png"
          alt="IDless Logo"
          style={{
            width: 64,
            height: 64,
            borderRadius: 12,
            objectFit: "cover",
            marginBottom: 20,
          }}
        />

        {/* Title */}
        <h3 style={{ marginBottom: 12 }}>No active chat in this tab</h3>


        {/* 🔥 Your reusable 1 / 2 steps */}
        <AppPrompt
          onOpenStore={handleOpenStore}
          onOpenApp={handleOpenApp}
          showStep2={false}
        />
      </div>
    </div>
  );
};

export default NoActiveChatsPage;